import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import auth from './auth';

auth.init().then(() => {
    createApp(App).mount('#app');
});
